import React, { useEffect } from "react";
import { Grid, Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import Axios from "axios";
import * as Constants from "../../consts/Constants.js";
import DefaultImage from "./images/defaultImage.png";
import check from "./images/check.png";
import cruz from "./images/cruz.png";
import NewExpanded from "./newsExpanded.js";
import Style from "../../styles/js/StyleNewHistory.js";
import Pagination from "@material-ui/lab/Pagination";

import { formatDateDDMMYYYYHHMM } from "../../utils/DateUtils";

export default function NewsHistory() {
  const style = Style();

  const [news, setNews] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [newsSelected, setNewsSelected] = React.useState({});
  //Constantes para la paginación
  const itemsPerPage = 9;
  const [page, setPage] = React.useState(1);
  const [noOfPages, setNoOfPages] = React.useState(0);

  let headers = {
    ...Axios.defaults.headers.common,
    Range: `items=0-${itemsPerPage - 1}`,
  };

  const getNews = () => {
    Axios.get(Constants.FINAL_URL_NOTICES, { headers: headers }).then(
      (response) => {
        let data = response.data;
        setNews(data);
        setNoOfPages(
          Math.ceil(response.headers.range.split("/")[1] / itemsPerPage)
        );
      }
    );
  };

  const getImage = (image) => {
    if (image === 0) return DefaultImage;
    return Constants.FINAL_URL_BINS + image;
  };

  const handleClickOpen = (newsItem) => {
    setOpen(true);
    setNewsSelected(newsItem);
  };

  const getSubcategory = (subcategory) => {
    return "- Subcategoria: " + subcategory;
  };

  const changeHeader = (lowerLimit, upperLimit) => {
    headers = {
      ...headers,
      Range: `items=${lowerLimit}-${upperLimit - 1}`,
    };
  };

  const handleChange = (event, value) => {
    setPage(value);
    changeHeader((value - 1) * itemsPerPage, value * itemsPerPage);
    getNews();
  };

  useEffect(() => {
    getNews();
  }, []);

  return (
    <div className={style.body}>
      <div>
        {" "}
        <Typography variant="h4" gutterBottom>
          Historial de noticias
        </Typography>
      </div>
      <div>
        <Grid container spacing={4} justify="center">
          {news != undefined &&
            news.map((newItem) => (
              <Grid item key={newItem.id}>
                <Card>
                  <CardActionArea onClick={() => handleClickOpen(newItem)}>
                    <div className={style.notificationPaper}>
                      <div className={style.firstColumn}>
                        <Typography className={style.titleInitial}>
                          {newItem.title}
                        </Typography>
                        <Typography className={style.bodyInitial}>
                          {newItem.body}
                        </Typography>
                        <div>
                          <Typography className={style.bodyInitial}>
                            Categoria: {newItem.category}{" "}
                            {newItem.subCategory !== undefined
                              ? getSubcategory(newItem.subCategory)
                              : null}
                          </Typography>
                        </div>{" "}
                        <Typography className={style.bodyInitial}>
                          Fecha de envío:{" "}
                          {formatDateDDMMYYYYHHMM(newItem.creationTime)}
                        </Typography>
                      </div>
                      <div className={style.secondColumn}>
                        {newItem.binId != 0 ? (
                          <img
                            src={getImage(newItem.binId)}
                            className={style.image}
                          />
                        ) : (
                          <div className={style.image}> </div>
                        )}

                        <div className={style.rowAlignEnd}>
                          <Typography variant="caption" component="p">
                            Alerta
                          </Typography>
                          {newItem.alert ? (
                            <img src={check} className={style.alertImage} />
                          ) : (
                            <img src={cruz} className={style.alertImage} />
                          )}
                        </div>
                      </div>
                    </div>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
        </Grid>
      </div>
      <div>
        <Pagination
          count={noOfPages}
          showFirstButton
          showLastButton
          onChange={handleChange}
        />
      </div>
      <NewExpanded {...{ open, setOpen, newsSelected }} />
    </div>
  );
}
